/** TanStack Query hooks for user search (used in editor selection). */
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/client';
import type { PaginatedResponse } from '@formency/shared';

export interface UserSearchResult {
  id: string;
  name: string | null;
  email: string;
  avatarUrl: string | null;
}

export const userKeys = {
  all: ['f', 'users'] as const,
  search: (query: string) => [...userKeys.all, 'search', query] as const,
};

/** Search users by name or email (min 2 chars). */
export function useSearchUsers(query: string) {
  return useQuery<PaginatedResponse<UserSearchResult>>({
    queryKey: userKeys.search(query),
    queryFn: () =>
      api.get<PaginatedResponse<UserSearchResult>>('/users', {
        searchQuery: query,
        pageSize: 10,
      }),
    enabled: query.length >= 2,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
